<style>
    .clearfix:after {
        content: '';
        display: block;
        visibility: hidden;
        clear: both;
    }

    .select-container {
        padding: 15px 2% 3px;
    }

    .select-left {
        float: left;
        display: table;
    }

    .select-left > div {
        vertical-align: top;
    }

    .select-left > div:not(:last-child) {
        margin-right: 5px;
    }

    .select-right {
        float: right;
    }

    textarea {
        border: 1;
        background-color: transparent;
        /*scrollbar-arrow-color:yellow;
        scrollbar-base-color:lightsalmon;
        overflow: hidden;*/
    / / color: #666464;
        height: auto;
        resize: none;
        border-left: 1px solid #5d94bf;
        border-right: 1px solid #5d94bf;
        border-top: 1px solid #5d94bf;
        border-bottom: 1px solid #5d94bf;
    }
</style>

<template>
    <div>
        <div class="select-container clearfix" style="margin-top: 6%;margin-left: 1%;float: center;">
            <el-form :model="userCertApply" :rules="checkNull" ref="ruleForm" class="demo-ruleForm"
                     label-width="40%">
                <el-form-item label="Mis账号:" style="width: 60%;margin-left: 7%;" prop="mis">
                    <el-input v-model="userCertApply.mis_id" disabled placeholder="mis账号"></el-input>
                </el-form-item>
                <el-form-item label="MAC地址:" style="width: 60%;margin-left: 7%;" prop="mis">
                    <el-input v-model="userCertApply.device_id" placeholder="00:00:00:00:00:00"></el-input>
                </el-form-item>
                <div style="margin-left: 45%;">
                    <el-button type="primary" @click="commitMisApply(userCertApply)">提交</el-button>
                </div>
            </el-form>
        </div>

    </div>
</template>

<script>
    import store from '../vuex/service/store'
    import axios from 'axios'
    import {mapState} from 'vuex';
    import util from '../views/util/commonUtil'

    export default {
        store: store,
        mounted: function () {
            var vm = this;
            if (vm.token == "") {
                var token = this.getCookie("access-token");
                if (token != null) {
                    vm.$store.commit('UPDATETOKEN', token);
                    vm.token = token;
                }
            }
            vm.getUser();
        },
        computed: mapState({
            loginRediret: function (state) {
                return state.loginRediret;
            },
            cookieName: function (state) {
                return state.cookieName;
            },
            temporaryWhiteAPI: function (state) {
                return state.temporaryWhiteAPI;
            },
            getuserAPI: function (state) {
                return state.getuserAPI;
            },
            userCertGetUrl: function (state) {
                return state.userCertGetUrl;
            },
            userCertAddOne: function (state) {
                return state.userCertAddOne;
            }
        }),
        filters: {
            idcExplain(val) {
                return util.idcExplain(val)
            },
            timeFormat(val) {
                return util.timeFormat(val)
            },
            switchColor(val) {
                return util.switchColor(val)
            },
            statusExplain(val) {
                return util.statusExplain(val)
            }
        },
        methods: {
            reset() {
                var vm = this;
                vm.name = '';
                vm.rasp = '';
                vm.proc = '';
                vm.ws = '';
                vm.query_arg = 'hostname';
                vm.query_value = '';
            },
            getCookie(name) {
                var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (arr = document.cookie.match(reg))
                    return unescape(arr[2]);
                else
                    return null;
            },
            kmUrl(URL) {
                window.open(URL);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            async commitMisApply(doc) {
                var vm = this;
                if (!doc.mis_id) {
                    vm.$message.error("Mis账号不能为空");
                    return;
                }
                if (!doc.device_id) {
                    vm.$message.error("MAC地址不能为空");
                    return;
                }
                var regex = /^([0-9a-fA-F]{2})(([/\s:][0-9a-fA-F]{2}){5})$/;
                if (!regex.test(doc.device_id)) {
                    vm.$message.error("MAC地址格式错误");
                    return;
                }
                let result = await vm.submitUserCert(doc);
                if (result['code'] !== 0) {
                    alert(result['message']);
                    return;
                }
                let url_result = await vm.getS3Url(doc);
                if (url_result['code'] !== 0) {
                    alert(url_result['message']);
                    return;
                }
                window.location.href = url_result['data'];
            },
            getCookie(name) {
                var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (arr = document.cookie.match(reg))
                    return unescape(arr[2]);
                else
                    return null;
            },
            getUser() {
                var vm = this;
                if (vm.user == null || vm.user == "") {
                    vm.user = vm.getCookie("username");
                    document.cookie = "ssoid=" + vm.getCookie("access-token");
                    axios.get(vm.getuserAPI, {
                        withCredentials: true
                    }).then((response) => {
                        if (response.data.status == 401) {
                            document.cookie = vm.cookieName + vm.$route.fullPath;
                            window.location = vm.loginRediret;
                        } else {
                            vm.userCertApply.mis_id = response.data.data.login;
                            if (vm.userCertApply.mis_id == null) {
                                vm.userCertApply.mis_id = vm.getCookie("username");
                            }
                            if (vm.userCertApply.mis_id == null) {
                                vm.userCertApply.mis_id = vm.getCookie("user").login;
                            }
                        }
                    }).catch(function (error) {
                        vm.requesterrorinfo(error)
                    })
                }
            },
            async submitUserCert(doc) {
                var vm = this;
                let response = await axios.get(vm.userCertAddOne, {
                    withCredentials: true,
                    params: {"misId": doc.mis_id, "deviceId": doc.device_id}
                });
                return response.data;
            },
            async getS3Url(doc) {
                var vm = this;
                let response = await axios.get(vm.userCertGetUrl, {
                    withCredentials: true,
                    params: {"misId": doc.mis_id, "deviceId": doc.device_id}
                });
                return response.data;
            },
            requesterrorinfo(error) {
                var vm = this;
                if (error.response) {
                    var code = error.response.status;
                    if (code == 401) {
                        vm.$message.error("401:您未登录");
                        var count = vm.getCookie("access-count")
                        window.location = vm.loginRediret;
                        if (count == null || count == 0) {
                            document.cookie = "access-count=1";
                            vm.$message('您未登录,请刷新');
                            document.cookie = vm.cookieName + vm.$route.fullPath;
                            window.location = vm.loginRediret;
                        } else {
                            vm.$message('您未登录,请刷新');
                        }
                    } else {
                        if (code == 404) {
                            vm.$notify({
                                title: '提示',
                                message: '404:Not found!',
                                type: 'error'
                            });
                        } else {
                            vm.$notify({
                                title: '提示',
                                message: '501:服务端未响应!',
                                type: 'error'
                            });
                        }
                    }
                } else {
                    vm.$notify({
                        title: '提示',
                        message: '502:服务端未响应!',
                        type: 'error'

                    });
                }
            }
        },
        data() {
            return {
                userCertApply: {
                    mis_id: '',
                    device_id: ''
                },
                checkNull: {
                    mis_id: [{required: true, message: 'MIS账号不能为空', trigger: 'blur'}, {
                        min: 1,
                        max: 50,
                        message: '长度在 50 个字以内',
                        trigger: 'blur'
                    }],
                    device_id: [{required: true, message: '申请原因不能为空', trigger: 'blur'}, {
                        min: 1,
                        max: 1000,
                        message: '长度在 200 个字以内',
                        trigger: 'blur'
                    }],
                },
            }
        }
    }
</script>
<style>
    .select1 {
        width: 100px;
    }

    .select2 {
        width: 130px;
    }

    .select3 {
        width: 160px;
    }

    .input1 {
        width: 350px;
    }

    .input2 {
        width: 210px;
    }

    .demo-table-expand label {
        width: 140px;
        color: #5d94bf;
    }
</style>



// WEBPACK FOOTER //
// userCertApply.vue?b058af86